import type { SubmenuRootItem } from '~/types/submenu'

interface SubmenuState {
  items: SubmenuRootItem[]
  isVisible?: boolean
  title?: string
}

export const useSubmenu = (): Ref<SubmenuState> =>
  useState<SubmenuState>('submenu', () => ({ items: [], title: undefined, isVisible: true }))

export const setSubmenu = (items: SubmenuRootItem[], title?: string): void => {
  const { value } = useSubmenu()
  value.items = items
  value.title = title
}

export const toggleSubmenu = (): void => {
  const s = useSubmenu()
  s.value.isVisible = !s.value.isVisible
}

export const isSubmenuVisible = (): boolean => {
  const s = useSubmenu()
  return s.value.isVisible ?? false
}

export const setSubmenuVisibility = (isVisible: boolean): void => {
  const s = useSubmenu()
  s.value.isVisible = isVisible
}
